import React, { useState } from 'react'
import { NavigateFn } from '@reach/router'
import WorkplaceGroupForm from './WorkplaceGroupForm'
import { IconButton, Dialog } from '@ui'
import { useReload } from '@hooks/reloadContext'

type NewWorkplaceDialogProps = {
  floorId?: string
  navigate?: NavigateFn
}
const NewWorkplaceDialog: React.FunctionComponent<NewWorkplaceDialogProps> = ({
  navigate,
}: {
  floorId?: string
  navigate?: NavigateFn
}) => {
  const [dirty, setDirty] = useState(false)

  const onClose = () => navigate && navigate(window.location.pathname)

  const reload = useReload()

  return (
    <Dialog
      isOpen
      style={{ width: 600, position: 'relative' }}
      canEscapeKeyClose={false}
      canOutsideClickClose={false}
      transitionDuration={200}
      isCloseButtonShown={false}
      title="New Workplace Group"
      onClose={onClose}
      toolbar={<DialogToolbar onClose={onClose} />}
      body={
        <WorkplaceGroupForm
          dirty={dirty}
          setDirty={setDirty}
          onSubmit={(newWorkplaceGroup) => {
            reload?.workplaceGroups()
            navigate && navigate(`?workplaceGroupId=${newWorkplaceGroup.id}`)
          }}
          onCancel={onClose}
        />
      }
    ></Dialog>
  )
}

function DialogToolbar({ onClose }: { onClose?: () => void }) {
  return (
    <div className="dialog-buttons">
      {onClose && <IconButton minimal tooltip="Close" iconName="times" onClick={onClose} />}
    </div>
  )
}

export default NewWorkplaceDialog
